export const getPriceCardColumns = ({
  totalApartments,
  totalParkings,
}: {
  totalApartments: number;
  totalParkings: number;
}) => {
  const apartmentColumns = Array.from(
    { length: totalApartments },
    (_, index) => ({
      key: `apartment${index + 1}`,
      label: `Wohnung ${index + 1}`,
      minWidth: 160,
      maxWidth: 160,
      justifyContent: "end",
    })
  );

  const parkingColumns = Array.from({ length: totalParkings }, (_, index) => ({
    key: `parking${index + 1}`,
    label: `Stellplatz ${index + 1}`,
    minWidth: 160,
    maxWidth: 160,
    justifyContent: "end",
  }));

  return [
    {
      key: "label",
      label: "",
      minWidth: 180,
      maxWidth: 1240,
      justifyContent: "start",
    },
    ...apartmentColumns,
    ...parkingColumns,
  ];
};
